/*
 * Copyright (c) 2018 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained here in is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
export const userTitleItems = [
    { name: "m", label: "M." },
    { name: "mme", label: "Mme" }
];

export const customerTitleItems = [
    { name: "mr", label: "Monsieur" },
    { name: "mrs", label: "Madame" },
    // { name: "miss", label: "Mademoiselle" }
];

export const customerFamilyStatusItems = [
    { name: "single", label: "Célibataire" },
    { name: "married", label: "Marié(e)" },
    { name: "divorced", label: "Divorcé(e)" },
    { name: "widower", label: "Veuf(ve)" },
    { name: "pacs", label: "Pacs" },
    { name: "freeUnion", label: "Union libre (concubinage)" }
];

export const idDocumentItems = [
    { name: "passport", label: "Passeport" },
    { name: "identityCard", label: "Carte nationale d'identité" },
    { name: "residencePermit", label: "Carte de séjour" }
];

export const addressProofItems = [
    { name: "electricityBill", label: "Facture d'électricité/gaz" },
    { name: "phoneBill", label: "Facture téléphone" },
    { name: "taxNotice", label: "Avis d'imposition" },
    { name: "other", label: "Autre :" }
];



// WEBPACK FOOTER //
// ./src/config/form.config.ts